import React from "react";
import { Outlet, redirect, useLoaderData } from "react-router-dom";
import styled from "styled-components";

// Imported actions
import { getUsaStates } from "../../../actions/geo";

// Imported components
import NavColumn from "./NavColumn";
import NavigationBar from "../../../components/nav/NavigationBar";

// Imported utils
import { isLoggedIn } from "../../../utils/user";

// Styled components
const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 120px max(40px, 3vw) 20px;
`;

const OutletContainer = styled.div`
  background: #F2F2F2;
  // border: 1px solid black;
  border-radius: 8px;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
`;

// Loader for router
export const loader = async () => {
  if (!isLoggedIn()) {
    return redirect("/login");
  } else {
    const usStates = await getUsaStates();

    return {
      usStates,
    };
  }
};

const UserProfilePage = () => {
  const loaderData = useLoaderData();

  return (
    <Container>
      <NavigationBar />
      <NavColumn />
      <OutletContainer>
        <Outlet context={loaderData} />
      </OutletContainer>
    </Container>
  );
};

export default UserProfilePage;
